import React from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import styled from 'styled-components'
import useTourV2VariationDetails from 'hooks/TourV2/useTourV2VariationDetails'
import Modal from 'components/Luxkit/Modal/Modal'
import TourV2ItemInclusions from 'components/OfferPage/TourV2/TourV2ItemInclusions'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  variation: Tours.V2OfferVariation
  inclusionItems: Array<Tours.InclusionItem>
}
const CaptionContainer = styled.div`
  align-items: center;
  display: flex;

  > * + *::before {
    content: '·';
    margin: 0 ${rem(4)};
    speak-as: bullets;
    speak: none;
  }

  &.horizontal-view {
     margin-top: ${rem(8)};
  }
`
const InclusionContainer = styled.div`
  margin-bottom: ${rem(24)}
`
const ListInclusion = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${rem(12)};
  gap: ${rem(8)};
`

function TourV2AllInclusionsModal({ variation, inclusionItems }: Props) {
  const {
    durationInDaysCount,
    countriesCount,
    placesCount,
    hasTheSameStartAndEndLocation,
    startLocation,
    endLocation,
  } = useTourV2VariationDetails(variation)

  return <Modal title={variation.name}>
    <CaptionContainer>
      <BodyText variant="medium" colour="neutral-two">
        {hasTheSameStartAndEndLocation && <span>Starts and ends in <b>{endLocation}</b></span>}
        {!hasTheSameStartAndEndLocation && <span>Starts in <b>{startLocation}</b>. Ends in <b>{endLocation}</b></span>}
      </BodyText>
      <BodyText variant="medium">{durationInDaysCount}</BodyText>
      {placesCount && <BodyText variant="medium">{placesCount}</BodyText>}
      {countriesCount && <BodyText variant="medium">{countriesCount}</BodyText>}
    </CaptionContainer>
    <InclusionContainer>
      <ListInclusion>
        <BodyText weight="bold" variant="large">Highlights included</BodyText>
        <VerticalSpacer gap={4}><TourV2ItemInclusions inclusions={inclusionItems} /></VerticalSpacer>
      </ListInclusion>
    </InclusionContainer>
  </Modal>
}

export default TourV2AllInclusionsModal
